import axios from 'axios';
import { PLAYGROUND_SEARCH_BACKEND_PRODUCTION_URL } from '../utils/consts';

export default axios.create({
  baseURL: `${PLAYGROUND_SEARCH_BACKEND_PRODUCTION_URL}`,
});
